"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbAsisSessionStorageV2 = void 0;
const web_1 = require("../../../../features/session/web");
class MbAsisSessionStorageV2 extends web_1.MbSessionStorage {
    constructor(storage) {
        super(storage);
        this.saveSessionData = (newData) => {
            super.saveSessionData(newData);
            if (super.checkSecurityAndExpiration(newData)) {
                this.storage.setItem('tokenCredential', newData.accessToken);
            }
        };
        this.removeSavedSessionData = () => {
            super.removeSavedSessionData();
            this.storage.removeItem('tokenCredential');
        };
    }
}
exports.MbAsisSessionStorageV2 = MbAsisSessionStorageV2;
//# sourceMappingURL=index.js.map